
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'

import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VAxis from 'vux/src/components/v-chart/v-axis.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'


export default {
components: {
Datetime,
PopupPicker,
Countup,
VChart,
VAxis,
VLine,
VScale,
VTooltip
},
data() {
return {
pickerStatus:false,
dateStatus:false,
index:0,
total:0,
money1:0,
money2:0,
startDate:'',
endDate:'',
operater1:'',
operater:'请选择',
operater_id:0,
operaterArr:[],
list:
[
{"date":"2010-01-10","type":"总计","value":0},
{"date":"2010-01-10","type":"社区","value":0},
{"date":"2010-01-10","type":"进出","value":0}
]
}
},
created(){
this.setDate();
this.getData();
},
methods: {
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.endDate);
console.log(date);
nowDate.setMonth(nowDate.getMonth()-1);
var date1 = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
},
showOperater(){
this.pickerStatus = true;
},
getData() {
this.$api.countReward({startDate:this.startDate,endDate:this.endDate}).then((res)=>{
if(res){
this.list = res.data.list;
this.total = res.data.total;
this.money1 = res.data.money1;
this.money2 = res.data.money2;
this.$refs.echart.rerender();
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/countReward.vue